/**
 * @description Les icônes des listes de surveillance.
 * - PEP : Politically Exposed Person
 * - SAN-PERSON : Sanction List
 * @remarks On ne conserve que les icônes correspondantes à PEP ou Sanction (les autres sont ignorées).
 */
export enum WatchlistIconType {
  /** Politically Exposed Person */
  PEP = "PEP",
  /** Sanction List */
  SAN_PERSON = "SAN-PERSON",
  /** Sanction List */
  SAN_ENTITY = "SAN-ENTITY",
  /** Sanction List */
  SIE = "SIE",
}

/**
 * @description Vérifie si une valeur est un type de watchlist.
 * @see {@link WatchlistIconType}
 */
export const isWatchlistIconType = (value: string): value is WatchlistIconType => {
  return Object.values(WatchlistIconType).includes(value as WatchlistIconType);
};
